import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Hero from "@/components/site/Hero";
import FreePackage from "@/components/site/FreePackage";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import TrustBadges from "@/components/site/TrustBadges";
import Testimonials from "@/components/site/Testimonials";
import HomeValueMortgage from "@/components/site/HomeValueMortgage";
import Contact from "@/components/site/Contact";
import OCLifestyle from "@/components/site/OCLifestyle";
import Probates from "@/pages/Probates";
import ReferralServices from "@/pages/ReferralServices";
import MarketYourHome from "@/pages/MarketYourHome";
import AboutUs from "@/pages/AboutUs";
import ContactPage from "@/pages/ContactPage";
import WhenProbateNeeded from "@/pages/WhenProbateNeeded";
import ProbateFAQs from "@/pages/ProbateFAQs";
import StepsToSellInheritedHome from "@/pages/StepsToSellInheritedHome";

function Home() {
  return (
    <Layout>
      <Hero />
      <FreePackage />
      <Services />
      <Process />
      <TrustBadges />
      <Testimonials />
      <OCLifestyle />
      <HomeValueMortgage />
      <Contact />
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/probates" element={<Probates />} />
        <Route path="/when-probate-needed" element={<WhenProbateNeeded />} />
        <Route path="/steps-to-sell-inherited-home" element={<StepsToSellInheritedHome />} />
        <Route path="/probate-faqs" element={<ProbateFAQs />} />
        <Route path="/referral-services" element={<ReferralServices />} />
        <Route path="/market-your-home" element={<MarketYourHome />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
